import Icon from '@components/icon/Icon';
import { mdiFileDocumentEdit } from '@mdi/js';
import { Button } from '@trussworks/react-uswds';
import { useModal } from '@stores';
import { isUserProfileAgent } from '@forms/components/modals/_shared/UserProfileAgent';
import '@pages/PublicNotices/public-notices-table/actionsTableCell.scss';
import { useUserProfile } from '@hooks';

const getContactId = (row, rowData) => row?.original?.contactID ?? rowData.indexOf(row.original);

const getModalProps = ({ row, id, isReadOnly, rowData, onUpdate, questionType, userProfileData }) => ({
  data: row.original,
  edit: true,
  id,
  isReadOnly,
  rowData,
  rowIndex: row.index,
  onUpdate,
  questionType,
  userProfileData,
});

const shouldHideButtonContainer = (rowOriginal, userProfileData) =>
  isUserProfileAgent(rowOriginal, userProfileData?.firstName, userProfileData?.lastName, userProfileData?.emailAddress);

const ContactActionsTableCell = ({ modalComponent, row, isReadOnly, rowData, rowIndex, onUpdate, questionType }) => {
  const { openModal } = useModal();
  const { userProfileData } = useUserProfile();

  const id = getContactId(row, rowData);
  const modalProps = getModalProps({ row, id, isReadOnly, rowData, rowIndex, onUpdate, questionType, userProfileData });

  const handleButtonClick = () => openModal(modalComponent, modalProps);

  return (
    <div className='button-container' hidden={shouldHideButtonContainer(row?.original, userProfileData)}>
      <Button className='edit-contact' title={'Edit Contact'} onClick={() => handleButtonClick()} disabled={isReadOnly}>
        <Icon aria-label={'Edit Contact'} focusable={false} path={mdiFileDocumentEdit} size={'24px'} />
      </Button>
    </div>
  );
};

export default ContactActionsTableCell;
